import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import DashboardContent from "./components/DashboardContent";
import UsersPage from "./pages/Users/UsersPage";
import AdminLogin from "./pages/AdminLogin";
import PackagesPage from "./pages/Packages/Packages";
import ActivitiesExcursionsPage from "./pages/ActivitiesExcusions/ActivitiesExcusions";
import CountriesPage from "./pages/Countries/Countries";
import CitiesPage from "./pages/Cities/Cities";
import TagsPage from "./pages/Tags/Tags";
import StaysPage from "./pages/Stays/Stays";
import Mtour from "./mtour"; 

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ✅ Default website at root */}
        <Route path="/" element={<Mtour />} />

        {/* ✅ Login page */}
        <Route path="/login" element={<AdminLogin />} />

        {/* ✅ Shared layout for dashboard-style pages */}
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<DashboardContent />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/packages" element={<PackagesPage />} />
          <Route path="/activitiesexcursions" element={<ActivitiesExcursionsPage />} />
          <Route path="/countries" element={<CountriesPage />} />
          <Route path="/cities" element={<CitiesPage />} />
          <Route path="/tags" element={<TagsPage />} />
          <Route path="/stays" element={<StaysPage />} />

        </Route>
      </Routes>
    </BrowserRouter>
  );
}
